import { ApiResponse, SearchApi, SearchWorkRequest, SolrResultSolrWorkReduced, SolrWorkReduced } from '../../api/core';
import { getAuthMiddleware } from '../../Auth/utils/GetAuthMiddleware';
import * as React from 'react';
import { ReactNode, useContext } from 'react';
import { AuthContext } from '../../Auth/components/AuthProvider';
import SearchResults, { ExternalSearchResultProps } from './SearchResults';
import { workFacetsSettings } from '../../Settings/search/work-facets';
import { worksDefaultSort } from '../../Settings/config';
import { worksSortOptions, worksSortOptionsProfile } from '../../Settings/data';
import { FormattedMessage } from 'react-intl';
import { SearchResultWork } from './components/SearchResultWork';
import { CitationDialog } from '../components/CitationDialog';
import { useLocation } from 'react-router';

export function SearchResultsWork(props: ExternalSearchResultProps): ReactNode {
  const {actions} = useContext(AuthContext);
  const api: SearchApi = new SearchApi().withMiddleware(getAuthMiddleware(actions));
  const [citation, setCitation] = React.useState<number>(null);
  const location = useLocation();

  const renderResult = (result: SolrWorkReduced, index: number): ReactNode =>
    <SearchResultWork key={index} position={index+1} result={result} showCitation={(): void => setCitation(parseInt(result.id, 10))} redirectPath={props.externalParams ? location.pathname : undefined}/>
  ;

  return <>
    <CitationDialog id={citation} visible={citation !== null}
                    setVisible={(visible: boolean): void => setCitation(visible ? citation : null)}/>
    <SearchResults
      searchFunction={async (requestParameters: SearchWorkRequest): Promise<SolrResultSolrWorkReduced | null> => {
        const results: ApiResponse<SolrResultSolrWorkReduced> = await api.searchWorkRaw(requestParameters);
        if (!results.raw.status) {
          return null;
        }
        return await results.value();
      }}
      externalParams={props.externalParams}
      defaultSortOption={worksDefaultSort}
      facetSettings={workFacetsSettings}
      title={<FormattedMessage id="search.work.banner.subtitle"/>}
      sortOptions={[...(props.externalParams ? worksSortOptionsProfile : worksSortOptions)]}
      renderResult={renderResult}
      path={'/search/works'}
      headerImage={require('../../Settings/img/banners/search/work.svg')}
    />
  </>;
}

export default SearchResultsWork;
